export default {
  name: 'widgetHelper',
  methods: {
    handleWidgetSubmit(navAction) {
      try {
        // Populate widget
        const firstNameDom = document.querySelector('.personal-info-page #firstName');
        if (firstNameDom) {
          firstNameDom.value = this.pu_firstName;
        }
        const lastNameDom = document.querySelector('.personal-info-page #lastName');
        if (lastNameDom) {
          lastNameDom.value = this.pu_lastName;
        }

        if (this.pu_dob) {
          const splitDob = this.pu_dob.split('/');
          const monthDom = document.querySelector('.personal-info-page #month');
          if (monthDom) {
            // eslint-disable-next-line prefer-destructuring
            monthDom.value = splitDob[0];
          }
          const dayDom = document.querySelector('.personal-info-page #day');
          if (dayDom) {
            // eslint-disable-next-line prefer-destructuring
            dayDom.value = splitDob[1];
          }
          const yearDom = document.querySelector('.personal-info-page #year');
          if (yearDom) {
            // eslint-disable-next-line prefer-destructuring
            yearDom.value = splitDob[2];
          }
          const dobDom = document.querySelector('#birthdateEntered');
          if (dobDom) {
            dobDom.value = `${splitDob[2]}-${splitDob[0]}-${splitDob[1]}`;
          }
        }
        const ssnDom = document.querySelector('.personal-info-page #ssn');
        if (ssnDom && this.pu_ssn) {
          // eslint-disable-next-line prefer-destructuring
          ssnDom.value = this.pu_ssn.split('-')[2];
        }

        // Register widget form submit response handlers.
        window.onFinish = () => {
          this.$emit('invoke-next-page', navAction);
        };
        window.onError = () => {
          this.$emit('invoke-next-page', navAction);
        };
        window.onInit = () => {
          this.$emit('invoke-next-page', navAction);
        };

        // Forced to use jQuery here because custom events with colon are not supported
        // in vanilla js and widget triggers only this custom event names.
        // eslint-disable-next-line no-undef
        jQuery('#fs-steps').on('fs-steps:error fs-steps:systemerror fs-steps:validationerror fs-steps:setstep', () => {
          this.$emit('invoke-next-page', navAction);
        });

        // Submit widget
        document.querySelector('#identifyUserInitStep button').click();
      } catch (e) {
        // if something happens with the widget processing, it shouldn't stop AO flow.
        this.$emit('invoke-next-page', navAction);
      }
    },
  },
};
